import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import paymentService from '../../services/paymentService';
import { toast } from 'react-toastify';

const RazorpayCheckout = ({ packageDetails, onSuccess, onClose }) => {
	const { user, updateCredits } = useContext(AuthContext);
	const [loading, setLoading] = useState(false);

	const handlePayment = async () => {
		setLoading(true);
		try {
			const orderData = await paymentService.createOrder(packageDetails.type);
			const options = {
				key: orderData.keyId,
				amount: orderData.amount,
				currency: orderData.currency,
				name: 'Resumly',
				description: `${packageDetails.credits} Credits Package`,
				image: '/logo.png',
				order_id: orderData.orderId,
				prefill: {
					name: user?.name || '',
					email: user?.email || '',
					contact: user?.phone || ''
				},
				theme: { color: '#3B82F6' },
				handler: async function (response) {
					try {
						const verificationData = {
							razorpay_order_id: response.razorpay_order_id,
							razorpay_payment_id: response.razorpay_payment_id,
							razorpay_signature: response.razorpay_signature,
							packageType: packageDetails.type
						};
						const result = await paymentService.verifyPayment(verificationData);
						if (result.success) {
							toast.success(`${result.creditsAdded} credits added successfully! 🎉`);
							await updateCredits();
							onSuccess?.(result);
							onClose?.();
						} else {
							toast.error('Payment verification failed');
						}
					} catch (error) {
						// eslint-disable-next-line no-console
						console.error('Verification error:', error);
						toast.error('Payment verification failed');
					}
				},
				modal: {
					ondismiss: function () {
						setLoading(false);
						toast.info('Payment cancelled');
					}
				}
			};
			const razorpay = new window.Razorpay(options);
			razorpay.open();
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Order creation error:', error);
			toast.error('Failed to initiate payment');
			setLoading(false);
		}
	};

	return (
		<div className="p-6">
			<h3 className="text-xl font-bold mb-4">Purchase Credits</h3>
			<div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
				<div className="flex justify-between items-center mb-2">
					<span className="font-semibold">Package:</span>
					<span className="capitalize">{packageDetails.type}</span>
				</div>
				<div className="flex justify-between items-center mb-2">
					<span className="font-semibold">Credits:</span>
					<span className="text-blue-600 font-bold">{packageDetails.credits}</span>
				</div>
				<div className="flex justify-between items-center">
					<span className="font-semibold">Price:</span>
					<span className="text-green-600 font-bold">₹{packageDetails.price}</span>
				</div>
			</div>
			<div className="mb-6">
				<p className="text-sm text-gray-600 mb-2">✓ Secure payment via Razorpay</p>
				<p className="text-sm text-gray-600 mb-2">✓ Accepts UPI, Cards, Net Banking, Wallets</p>
				<p className="text-sm text-gray-600">✓ Credits added instantly after payment</p>
			</div>
			<div className="flex gap-3">
				<button
					onClick={handlePayment}
					disabled={loading}
					className="flex-1 bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
				>
					{loading ? 'Processing...' : 'Proceed to Pay'}
				</button>
				<button onClick={onClose} disabled={loading} className="px-6 py-3 border border-gray-300 rounded-lg font-semibold hover:bg-gray-50 disabled:opacity-50 transition-colors">
					Cancel
				</button>
			</div>
			<div className="mt-4 flex items-center justify-center">
				<img src="https://razorpay.com/assets/razorpay-glyph.svg" alt="Razorpay" className="h-6" />
				<span className="ml-2 text-sm text-gray-500">Powered by Razorpay</span>
			</div>
		</div>
	);
};

export default RazorpayCheckout;


